import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { navigate } from "@reach/router";
import PasswordForm from "./form";
import { AppContext, TOAST } from "../../context";
import { setPassword } from "../../infrastructure/actions";

const useStyles = makeStyles({
  container: {
    maxWidth: "1024px",
    width: "100%",
    margin: "16px auto",
  },
  paper: {
    padding: "16px",
  },
});

const SetPassword = (props) => {
  const classes = useStyles();
  const { dispatch } = useContext(AppContext);
  const { language, config } = useSelector((state) => ({
    config: state.infrastructure.config,
    language: state.language,
  }));
  const rdxDispatch = useDispatch();

  const redirect = (status) => {
    const goBackUrl = localStorage.getItem("goBackUrl");
    if (status < 400 && goBackUrl && goBackUrl.includes("booking")) {
      window.location.replace(
        `${config.authUrl.split("auth")[0]}booking?redirect=booking`
      );
    } else if (status < 400) {
      navigate(config.self);
    }
  };

  const handleSubmit = (values, actions) => {
    rdxDispatch(
      setPassword(props.id, values.newPassword, (response) => {
        if (response.status < 400) {
          dispatch({
            type: TOAST,
            payload: {
              text: language.Toasts.passwordSubmitSuccess,
              variant: "success",
            },
          });
          redirect(response.status);
        } else {
          response.text().then((text) => {
            if (text.length > 0) {
              dispatch({ type: TOAST, payload: { text, variant: "error" } });
            }
            if (text.length === 0) {
              dispatch({
                type: TOAST,
                payload: {
                  text: language.Toasts.setPasswordFailed,
                  variant: "error",
                },
              });
            }
            actions.resetForm();
          });
        }
      })
    );
  };

  return (
    <div className={classes.container}>
      <Typography variant="h1" gutterBottom>
        {language.SetPassword}
      </Typography>
      <PasswordForm
        initialValues={{
          newPassword: "",
          confirmPassword: "",
        }}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default SetPassword;
